<header class="menu-header">
	<div class="menu-icon">
		<button class="menu-toggle" data-cy="ToggleMenu" type="button" (click)="onToggle()">
			<span></span>
			<span></span>
			<span></span>
		</button>
	</div>
	<div class="menu-logo">
		<a [href]="('webSiteUrl' | branding)()">
			@if (('code' | branding)(); as brandingCode) {
				<img ngSrc="/assets/images/logos/logo_{{brandingCode.toLowerCase()}}_white.png" [width]="125" [height]="29" [alt]="('name' | branding)()">
			} @else {
				<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" [width]="125" [height]="29" [alt]="'App.Name' | translate">
			}
		</a>
	</div>
</header>
<ul #menulinks class="menu-links">
	<li>
		<a [routerLink]="routes.homePage" routerLinkActive="active">
			<i class="menu-icon fac fa-custom-home"></i>
			<span>{{ 'Menu.HomePage.Title' | translate }}</span>
		</a>
		<ul class="submenu-links">
			<li>
				<a [routerLink]="routes.fiOverviewPage" routerLinkActive="active">{{ 'Menu.HomePage.Item2' | translate }}</a>
			</li>
			<li>
				<a [routerLink]="routes.opOverviewPage" routerLinkActive="active">{{ 'Menu.HomePage.Item1' | translate }}</a>
			</li>
		</ul>
	</li>
	<li>
		<a [routerLink]="routes.superCustomersList" routerLinkActive="active">
			<i class="menu-icon fac fa-custom-portfolio"></i>
			<span>{{ 'Menu.SuperDebtors' | translate }}</span>
		</a>
	</li>
	<li>
		<a [routerLink]="routes.accountingList" routerLinkActive="active">
			<i class="menu-icon fac fa-custom-paperclip"></i>
			<span>{{ 'Menu.Accounting.Title' | translate }}</span>
		</a>
	</li>
	<li>
		<a [routerLink]="routes.adminToolsIndicatorsPage" routerLinkActive="active">
			<i class="menu-icon far fa-cog"></i>
			<span>{{ 'Menu.AdminTools.Title' | translate }}</span>
		</a>
		<ul class="submenu-links">
			<li>
				<a [routerLink]="routes.adminToolsIndicatorsPage" routerLinkActive="active" >{{ 'Menu.AdminTools.Item8' | translate }}</a>
			</li>
			<li>
				<a [routerLink]="routes.extradataPage" routerLinkActive="active" >{{ 'Menu.AdminTools.Item10' | translate }}</a>
			</li>
			<li>
				<a [routerLink]="routes.adminToolsReportsPage" routerLinkActive="active" >{{ 'Menu.AdminTools.Item9' | translate }}</a>
			</li>
			@if (isSupport) {
				<li>
					<a [routerLink]="routes.adminToolsWorkflowSchedulingInstancesList" routerLinkActive="active" >{{ 'Menu.AdminTools.Item5' | translate }}</a>
				</li>
			}
		</ul>
	</li>
</ul>
